import React from 'react';
import { Box } from '@mui/material';
import { launchStatusText, scheduleStatusText, workStatusText } from '../helpers';
import { launchStatusStyle, PillStyle, scheduleStatusStyle, workStatusStyle } from '../launchTheme';
import { LaunchStatus, ScheduleStatus, WorkStatus } from '../types';

interface StatusPillProps extends PillStyle {
  label: string;
  size?: 'small' | 'medium';
  icon?: React.ReactNode;
}

export const StatusPill: React.FC<StatusPillProps> = ({ label, fg, bg, border, size = 'small', icon }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      height: size === 'small' ? 22 : 26,
      px: size === 'small' ? 1.1 : 1.4,
      borderRadius: '13px',
      fontSize: size === 'small' ? 12 : 13,
      fontWeight: 600,
      lineHeight: 1,
      whiteSpace: 'nowrap',
      color: fg,
      bgcolor: bg,
      border: border || '1px solid transparent',
      fontVariantNumeric: 'tabular-nums',
    }}
  >
    {icon}
    {label}
  </Box>
);

export const WorkStatusPill: React.FC<{ status: WorkStatus; size?: 'small' | 'medium' }> = ({ status, size }) => (
  <StatusPill label={workStatusText[status]} size={size} {...workStatusStyle[status]} />
);

export const ScheduleStatusPill: React.FC<{ status: ScheduleStatus; detail?: string; size?: 'small' | 'medium' }> = ({ status, detail, size }) => (
  <StatusPill label={detail ? `${scheduleStatusText[status]} · ${detail}` : scheduleStatusText[status]} size={size} {...scheduleStatusStyle[status]} />
);

export const LaunchStatusPill: React.FC<{ status: LaunchStatus; size?: 'small' | 'medium' }> = ({ status, size }) => {
  const { fg, bg } = launchStatusStyle[status];
  return <StatusPill label={launchStatusText[status]} size={size} fg={fg} bg={bg} />;
};
